import React, { useState, useEffect } from 'react'
import Img from 'gatsby-image'
import { useStaticQuery, graphql } from "gatsby"

import './content-header.scss';

const ContentHeader = props => {
    const { mobile } = props;

    const resultQuery = useStaticQuery(
        graphql`
          query HEADER_LOYALTY_QUERY{
            allContentfulNolHomeTercerNivel(filter: {slug: {in: ["mis-puntos","mis-puntos/"]}}) {
                nodes {
                  node_locale
                  banner {
                    bannerSecciones {
                      description
                      file {
                        url
                        details {
                          image {
                            height
                          }
                        }
                      }
                      fluid(maxWidth: 1920, quality: 100) {
                        sizes
                        src
                        srcSet
                        srcSetWebp
                        srcWebp
                      }
                    }
                    
                    bannerSeccionesLogueado {
                        description
                        file {
                          url
                          details {
                            image {
                              height
                            }
                          }
                        }
                        fluid(maxWidth: 1920, quality: 100) {
                          sizes
                          src
                          srcSet
                          srcSetWebp
                          srcWebp
                        }
                      }
                  }
                }
              }
          }
        `
      )

    var imgMobile = resultQuery.allContentfulNolHomeTercerNivel.nodes.filter(e => e.node_locale === process.env.LOCALE)[0].banner.bannerSecciones[1]
    var imgPc = resultQuery.allContentfulNolHomeTercerNivel.nodes.filter(e => e.node_locale === process.env.LOCALE)[0].banner.bannerSecciones[0]

    var imgMobileLog = resultQuery.allContentfulNolHomeTercerNivel.nodes.filter(e => e.node_locale === process.env.LOCALE)[0].banner.bannerSeccionesLogueado[1]
    var imgPcLog = resultQuery.allContentfulNolHomeTercerNivel.nodes.filter(e => e.node_locale === process.env.LOCALE)[0].banner.bannerSeccionesLogueado[0]

    const [pageLoad, setPageLoad] = useState(false);
    const [isLog, setisLog] = useState(false)

    useEffect(() => {
        setPageLoad(true);
        if(localStorage.getItem("TOKEN_INFO")){
            setisLog(true)
        }
    })

    const setSrc = () => {
      if (isLog) {
          if (mobile) {
            return imgMobileLog.fluid
          } else {
            return imgPcLog.fluid
          }         
      }else {
        if (mobile) {
          return imgMobile.fluid
        } else {
          return imgPc.fluid
        } 
      }
    }

  return (
    <div className="f-header-articles-container">
      <div className="f-header-articles-content-section">
        <Img className="f-banner-main-article"
          loading='eager'
          fluid={setSrc()}
          alt={isLog ? imgMobileLog.description : imgMobile.description }
          style={{ 'height': mobile ? imgMobile.file.details.image.height : imgPc.file.details.image.height }}
        />
      </div>
    </div>
  )
}

export default ContentHeader
